import { Outlet } from 'react-router-dom'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { RequisitionsTable } from 'modules/ats/pages/JobsRequisitionsPage/RequisitionsTable'

const RequisitionsPage = () => {
  return (
    <ResponsivePage.Body variant="full" showHeader={false}>
      <RequisitionsTable />
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default RequisitionsPage
